
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 3100","fill":"currentColor"}},[_c('path',{attrs:{"data-name":"Path 2212","d":"M12.494 18.393H9.955l1.661-8.241h-.706V8.713h2.463l-1.659 8.243h.78z"}}),_c('path',{attrs:{"data-name":"Path 2213","d":"M13.631 7.428h-1.619l.416-2.09h1.618z"}})])])
          )
        }
      }
    